module.exports = __webpack_public_path__ + "img/guize.bc2093c6.png";